import list from 'src/modules/appUser/list/appUserListReducers';
import form from 'src/modules/appUser/form/appUserFormReducers';
import view from 'src/modules/appUser/view/appUserViewReducers';
import destroy from 'src/modules/appUser/destroy/appUserDestroyReducers';
import importerReducer from 'src/modules/appUser/importer/appUserImporterReducers';
import { combineReducers } from 'redux';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
